// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__3BT4Y","cookieConsentContainer":"App_cookieConsentContainer__2btwd","cookieConsentButton":"App_cookieConsentButton__2FHWO"};